import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.448 2.781c.5-.5 1.178-.781 1.885-.781h9.334a2.667 2.667 0 0 1 2.666 2.667V10a2.667 2.667 0 0 1-2.666 2.667H5.36l.503.496a.667.667 0 1 1-.937.949l-1.463-1.445h-.13A2.667 2.667 0 0 1 .666 10V4.667c0-.708.28-1.386.78-1.886m1.885.552A1.333 1.333 0 0 0 2 4.667V5h12v-.333a1.333 1.333 0 0 0-1.333-1.334zM2 6.333V10a1.333 1.333 0 0 0 1.333 1.333h.155l1.792-1.316a.667.667 0 1 1 .79 1.075l-.33.241h6.927A1.333 1.333 0 0 0 14 10V6.333z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7 7.666a.74.74 0 0 1-.132.43.54.54 0 0 1-.439.237H3.572a.54.54 0 0 1-.44-.237.74.74 0 0 1-.132-.43.74.74 0 0 1 .132-.428.54.54 0 0 1 .44-.238h2.857c.201 0 .352.115.44.238A.74.74 0 0 1 7 7.666"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })